import { RootState } from '@/types/common';
import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { createStateSyncMiddleware, initMessageListener } from 'redux-state-sync';
import { shouldSyncReduxAction } from './units';
import rootReducer from './reducers';

const store = configureStore({
  devTools: true,
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      createStateSyncMiddleware({
        predicate: action => shouldSyncReduxAction(action?.type?.toString() || ''),
      })
    ),
});

store.subscribe(() => {});

initMessageListener(store);

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
